import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  EntityHeaderService,
  EntityHeaderContainerModel, 
  Pagination
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';
@Component({
  selector: 'select-employee-drop-down',
  templateUrl: './select-employee-drop-down.component.html',
  styleUrls: ['./select-employee-drop-down.component.css']
})
export class SelectEmployeeDropDownComponent implements OnInit, OnDestroy {

  @Input() employeeControl: FormControl;
  @Input() label: any;

  @Output() salesAgentChange = new EventEmitter<FormControl>();
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();
  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<EntityHeaderContainerModel[]> = new ReplaySubject<EntityHeaderContainerModel[]>(1);
  entityList: EntityHeaderContainerModel[];
  fieldLabel: string;

  constructor( private employeeService: EntityHeaderService ) {}

  ngOnInit() {
    this.fieldLabel = this.label;
    console.log("fieldLabel", this.fieldLabel)
  
    let pagination = new Pagination(0, 300, [{columnName: 'is_employee', operator: '=', value: 'true'}])
    this.subs.sink = this.employeeService.getByCriteria(pagination, this.apiVisa).subscribe(
      {next: resolve => {
        this.entityList = resolve.data;
        this.filteredOptions$.next(this.entityList);
      }});

    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterEmployee(resolve)});
  }

  filterEmployee(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.bl_fi_mst_entity_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

